import { setName } from '@/tableDefinitionEditor/tableDefinition.actions';
import { EDITOR_TYPES } from '@/tableDefinitionEditor/tableDefinition.constants';

export const setTreeBuilderName = (name: string) => setName(EDITOR_TYPES.ITEM, name);
